import instance from '../../../api/axios'
import { Whiteboard, WhiteboardRaw } from '../../Whiteboard/types/whiteboard'
import { CreateObjective, Objective, ObjectiveRaw } from '../types/objective'

const parseWhiteboard = (whiteboard: WhiteboardRaw): Whiteboard => ({
  ...whiteboard,
  excalidrawElement: whiteboard.excalidrawElement
    ? JSON.parse(whiteboard.excalidrawElement)
    : [],
  excalidrawFiles: whiteboard.excalidrawFiles
    ? JSON.parse(whiteboard.excalidrawFiles)
    : undefined,
})

const parseObjective = (objective: ObjectiveRaw): Objective => ({
  ...objective,
  steps: (objective.steps ?? []).map((step) => ({
    ...step,
    toDoes: step.toDoes ?? [],
  })),
  whiteboards: objective.whiteboards?.length
    ? objective.whiteboards
        .map(parseWhiteboard)
        .sort((a: Whiteboard, b: Whiteboard) =>
          b.createdAt.localeCompare(a.createdAt),
        )
    : [],
})

export const loadObjectives = async (): Promise<Objective[]> => {
  const response = await instance.get('/objectives')
  return response.data
    ? response.data.map((objective: ObjectiveRaw) => parseObjective(objective))
    : []
}

export const loadObjective = async (id: number): Promise<Objective> => {
  const response = await instance.get(`/objectives/${id}`)
  return response.data ? parseObjective(response.data) : response.data
}

export const saveObjective = async (
  objective: CreateObjective,
): Promise<Objective> => {
  const response = await instance.post('/objectives', objective)
  return response.data
}

export const modifyObjective = async (
  objective: Objective,
): Promise<Objective> => {
  const response = await instance.put('/objectives', objective)
  return response.data
}

export const removeObjective = async (id: number): Promise<number> => {
  const response = await instance.delete(`/objectives/${id}`)
  return response.data
}
